// import React, { useEffect, useMemo, useState } from "react";
// import { Container, Row, Col, Form, Alert } from "react-bootstrap";
// import { useTranslation } from "react-i18next";
// import { PhoneCall, MapPin, CalendarClock, Mail } from "lucide-react";
// import AftersalesSupportSection from "../../components/sections/AftersalesSupportSection/AftersalesSupportSection";

// import RiyadhShowroomBanner from "../../assets/images/riyadh-showroom.jpg";

// import "./LocationPage.css";

// const LOCATIONS = [
//   {
//     id: "riyadh-showroom-1",
//     type: "showroom",
//     city: "Riyadh",
//     isDefault: true,
//     branchName: "LANDKING Showroom - Riyadh",
//     banner: RiyadhShowroomBanner,
//     contacts: ["8001240664"],
//     emails: ["info@btatc.com"],
//     addressText: "Eastern Ring Road Exit 18, Riyadh",
//     workingDays: "Sunday to Thursday",
//     workingTime: "9:00 AM to 6:00 PM",
//     mapLink: "https://maps.app.goo.gl/nFcCguNArbaEVaST8?g_st=iw",
//     mapEmbedUrl:
//       "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3281.864978891304!2d46.798778899999995!3d24.6381961!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e2f0729f48095f1%3A0xea5a4a23b7659451!2zTEFOREtJTkcgfCDZhNin2YbYr9mD2YbYrA!5e1!3m2!1sen!2ssa!4v1771249656339!5m2!1sen!2ssa",
//   },

//   {
//     id: "riyadh-service-1",
//     type: "service",
//     city: "Riyadh",
//     isDefault: true,
//     branchName: "LandKing Service Provider - Al Suwaidi, Riyadh",
//     contacts: ["011-4256557", "053-5067078"],
//     emails: ["FR2@FUCHS.COM.SA"],
//     addressText: "Al Suwaidi Exit-25",
//     workingDays: "Saturday to Thursday",
//     workingTime: "8:00 AM to 5:00 PM",
//     trucksServing: ["4 Ton", "5 Ton", "6 Ton"],
//     mapLink: "https://goo.gl/maps/GxHRfY8XXeq",
//     mapEmbedUrl:
//       "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3283.648625899599!2d46.6665498002994!3d24.570213325568865!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e2f10202358a537%3A0xdf97d67d6c98800d!2sFuchs%20One%20Stop%20Al%20Suwaidi!5e1!3m2!1sen!2ssa!4v1772615971368!5m2!1sen!2ssa",
//   },
//   {
//     id: "riyadh-service-2",
//     type: "service",
//     city: "Riyadh",
//     isDefault: false,
//     branchName: "LandKing Service Provider - Old Kharj Road, Riyadh",
//     contacts: ["059-4396635"],
//     emails: ["FR27@FUCHS.COM.SA"],
//     addressText: "Ind. Area, Old Kharj Road",
//     workingDays: "Sunday to Thursday",
//     workingTime: "8:00 AM to 5:00 PM",
//     trucksServing: ["4 Ton", "5 Ton", "6 Ton"],
//     mapLink: "https://maps.app.goo.gl/5vRwJsmtWeoVCXNLA",
//     mapEmbedUrl:
//       "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d877.5717330280029!2d46.86738895101853!3d24.54787480882297!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e2fa196429d78e5%3A0xfc6f6112acf71b7c!2sFuchs%20One%20Stop%202Nd%20Industrial%20Area!5e1!3m2!1sen!2ssa!4v1772616224144!5m2!1sen!2ssa",
//   },
//   {
//     id: "dammam-service-1",
//     type: "service",
//     city: "Dammam",
//     isDefault: false,
//     branchName: "LandKing Service Provider - Ibn Khaldon King Fahad Road, Dammam",
//     contacts: ["058-3340189"],
//     emails: ["FD3@FUCHS.COM.SA"],
//     addressText: "Ibn Khaldon King Fahad Road",
//     workingDays: "Sunday to Thursday",
//     workingTime: "8:00 AM to 5:00 PM",
//     trucksServing: ["4 Ton", "5 Ton", "6 Ton"],
//     mapLink: "https://maps.app.goo.gl/5vRwJsmtWeoVCXNLA",
//     mapEmbedUrl:
//       "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1616.7473728265613!2d50.08582391508435!3d26.41934542457861!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e49fc8e1e62635b%3A0x8ef9da91fabdfbc9!2sFuchs%20One%20Stop!5e1!3m2!1sen!2ssa!4v1772620712644!5m2!1sen!2ssa"
//   },
//   {
//     id: "jeddah-service-1",
//     type: "service",
//     city: "Jeddah",
//     isDefault: false,
//     branchName: "LandKing Service Provider - Obhur",
//     contacts: ["059-8597408"],
//     emails: ["FJ13@FUCHS.COM.SA"],
//     addressText: "Obhur (Al-Bandr Dist)",
//     workingDays: "Sunday to Thursday",
//     workingTime: "8:00 AM to 5:00 PM",
//     trucksServing: ["4 Ton", "5 Ton", "6 Ton"],
//     mapLink: "https://goo.gl/maps/yyXMNJANvw42",
//     mapEmbedUrl:
//       "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1676.67810155223!2d39.1183358!3d21.7578324!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15c1630236dff215%3A0xcac6e01c93d06cac!2sFuchs%20One%20Stop%20Obhour!5e1!3m2!1sen!2ssa!4v1772618411730!5m2!1sen!2ssa",
//   },
//   {
//     id: "jeddah-service-2",
//     type: "service",
//     city: "Jeddah",
//     isDefault: false,
//     branchName: "LandKing Service Provider - Jizan Road (Heraj Siyarat)",
//     contacts: ["054-2870067", "050-9599104"],
//     emails: ["FJ21@FUCHS.COM.SA"],
//     addressText: "Jizan Road (Heraj Siyarat)",
//     workingDays: "Sunday to Thursday",
//     workingTime: "8:00 AM to 5:00 PM",
//     trucksServing: ["4 Ton", "5 Ton", "6 Ton"],
//     mapLink: "https://maps.app.goo.gl/eEFEN2cEvSunVvaf8",
//     mapEmbedUrl:
//       "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d233.33373894576866!2d39.25121549083948!3d21.42939854447394!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15c3cbee48481259%3A0xe1c2b63a8f0ce33e!2sFuchs%20One%20Stop%20Al%20Haraj!5e1!3m2!1sen!2ssa!4v1772618611892!5m2!1sen!2ssa",
//   },
//   {
//     id: "makkah-service-2",
//     type: "service",
//     city: "Makkah",
//     isDefault: false,
//     branchName: "LandKing Service Provider - Shokiya District",
//     contacts: ["053-8025917", "059-9463354"],
//     emails: ["FM3@FUCHS.COM.SA"],
//     addressText: "Jizan Road (Heraj Siyarat)",
//     workingDays: "Sunday to Thursday",
//     workingTime: "8:00 AM to 5:00 PM",
//     trucksServing: ["4 Ton", "5 Ton", "6 Ton"],
//     mapLink: "https://maps.app.goo.gl/tGMbkGjUA4Scrvbj8",
//     mapEmbedUrl:
//       "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d210.11969650334197!2d39.796576945785716!3d21.38844118529821!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15c21be918a23f07%3A0xbc71cde32b7edf3a!2zRlVDSFMgT05FU1RPUCDZgdmI2YPYsyDZiNmGINiz2KrZiNio!5e1!3m2!1sen!2ssa!4v1772618773266!5m2!1sen!2ssa",
//   },
//   {
//     id: "rabigh-service-1",
//     type: "service",
//     city: "Rabigh",
//     isDefault: false,
//     branchName: "LandKing Service Provider - Rabigh",
//     contacts: ["058-3663948", "058-0860262"],
//     emails: ["FRBG1@FUCHS.COM.SA"],
//     addressText: "Rabigh",
//     workingDays: "Sunday to Thursday",
//     workingTime: "8:00 AM to 5:00 PM",
//     trucksServing: ["4 Ton", "5 Ton", "6 Ton"],
//     mapLink: "https://goo.gl/maps/uuoegmoPzcG2",
//     mapEmbedUrl:
//       "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1664.7979389425486!2d39.037312383768906!3d22.753383392551836!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15c094485cae5b15%3A0x4ceafe87f06e96e8!2sFuchs%20One%20Stop%20Al%20Joud!5e1!3m2!1sen!2ssa!4v1772618976490!5m2!1sen!2ssa"
//   },
//   {
//     id: "madinah-service-1",
//     type: "service",
//     city: "Madinah",
//     isDefault: false,
//     branchName: "LandKing Service Provider - Prince Moh’d. Bin Abdullaziz, Madinah City",
//     contacts: ["056-9437061"],
//     emails: ["FMD4@FUCHS.COM.SA"],
//     addressText: "Prince Moh’d. Bin Abdullaziz",
//     workingDays: "Sunday to Thursday",
//     workingTime: "8:00 AM to 5:00 PM",
//     trucksServing: ["4 Ton", "5 Ton", "6 Ton"],
//     mapLink: "https://goo.gl/maps/uktrCfi1QyWPFUQR6",
//     mapEmbedUrl:
//       "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d228.1074780783279!2d39.62366506478214!3d24.492067480510283!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjTCsDI5JzMxLjUiTiAzOcKwMzcnMjUuOSJF!5e1!3m2!1sen!2ssa!4v1772619232093!5m2!1sen!2ssa"
//   },
//   {
//     id: "yanbu-service-1",
//     type: "service",
//     city: "Yanbu",
//     isDefault: false,
//     branchName: "LandKing Service Provider - Yanbu",
//     contacts: ["050-0601706"],
//     emails: ["FY1@FUCHS.COM.SA"],
//     addressText: "Yanbu City",
//     workingDays: "Sunday to Thursday",
//     workingTime: "8:00 AM to 5:00 PM",
//     trucksServing: ["4 Ton", "5 Ton", "6 Ton"],
//     mapLink: "https://goo.gl/maps/uktrCfi1QyWPFUQR6",
//     mapEmbedUrl:
//       "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1648.143668668211!2d38.0613792!3d24.0833402!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15b9060a61aa7b89%3A0x286f8fe8b194c96d!2sFuchs%20One%20Stop%20Al%20Khurik!5e1!3m2!1sen!2ssa!4v1772619394409!5m2!1sen!2ssa"
//   },
//   {
//     id: "tabuk-service-1",
//     type: "service",
//     city: "Tabuk",
//     isDefault: false,
//     branchName: "LandKing Service Provider - Tabuk",
//     contacts: ["059-7163599"],
//     emails: ["FT1@FUCHS.COM.SA"],
//     addressText: "Tabuk",
//     workingDays: "Sunday to Thursday",
//     workingTime: "8:00 AM to 5:00 PM",
//     trucksServing: ["4 Ton", "5 Ton", "6 Ton"],
//     mapLink: "https://goo.gl/maps/uktrCfi1QyWPFUQR6",
//     mapEmbedUrl:
//       "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3176.3912153542424!2d36.567965900000004!3d28.388265999999994!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15a9ad0733da3eb5%3A0xa3365cf04d3716cb!2sFuchs%20One%20Stop%20Al%20Azizya!5e1!3m2!1sen!2ssa!4v1772619607126!5m2!1sen!2ssa"
//   },
//   {
//     id: "sakaka-service-1",
//     type: "service",
//     city: "Sakaka",
//     isDefault: false,
//     branchName: "LandKing Service Provider - Sakaka",
//     contacts: ["058-1834037"],
//     emails: ["FSK1@FUCHS.COM.SA"],
//     addressText: "Sakaka",
//     workingDays: "Sunday to Thursday",
//     workingTime: "8:00 AM to 5:00 PM",
//     trucksServing: ["4 Ton", "5 Ton", "6 Ton"],
//     mapLink: "https://maps.app.goo.gl/stP8LYCAavCvdgFU9",
//     mapEmbedUrl:
//       "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d217.15431474409542!2d40.18867294014847!3d29.966017558614045!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1572bb336480763b%3A0xbd8fc711cd3b0673!2sOne%20stop%20fuchs!5e1!3m2!1sen!2ssa!4v1772619730668!5m2!1sen!2ssa"
//   },
//   {
//     id: "kahmis-mushait-service-1",
//     type: "service",
//     city: "Khamis Mushait",
//     isDefault: false,
//     branchName: "LandKing Service Provider - Khamis Mushait",
//     contacts: ["058-0105749"],
//     emails: ["FA5@FUCHS.COM.SA"],
//     addressText: "Khamis Mushait",
//     workingDays: "Sunday to Thursday",
//     workingTime: "8:00 AM to 5:00 PM",
//     trucksServing: ["4 Ton", "5 Ton", "6 Ton"],
//     mapLink: "https://maps.app.goo.gl/xXcxK4GkfRnLpfsd6",
//     mapEmbedUrl:
//       "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d237.9863923234643!2d42.68790288192259!3d18.299191804414683!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15fb50aabb14cba1%3A0x36559018ec7b7ba3!2sFuchs%20One%20Stop%20Al%20Mazab!5e1!3m2!1sen!2ssa!4v1772619935775!5m2!1sen!2ssa"
//   },
//   {
//     id: "bisha-service-1",
//     type: "service",
//     city: "Bisha",
//     isDefault: false,
//     branchName: "LandKing Service Provider - Airport Road, Bisha",
//     contacts: ["059-0485894"],
//     emails: ["FBS1@FUCHS.COM.SA"],
//     addressText: "Bisha",
//     workingDays: "Sunday to Thursday",
//     workingTime: "8:00 AM to 5:00 PM",
//     trucksServing: ["4 Ton", "5 Ton", "6 Ton"],
//     mapLink: "https://goo.gl/maps/dzCQjeWe7aQ2",
//     mapEmbedUrl:
//       "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d942.1584824634714!2d42.61943612847446!3d20.004009598832724!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15f02957900bb893%3A0x63e8976185bf6a1f!2sFuchs%20One%20Stop%20Alkhozama!5e1!3m2!1sen!2ssa!4v1772620065506!5m2!1sen!2ssa"
//   },
//   {
//     id: "Jizan-service-1",
//     type: "service",
//     city: "Jizan",
//     isDefault: false,
//     branchName: "LandKing Service Provider - Sabiya, Jizan",
//     contacts: ["058-0814334"],
//     emails: ["FJZ2@FUCHS.COM.SA"],
//     addressText: "Sabiya",
//     workingDays: "Sunday to Thursday",
//     workingTime: "8:00 AM to 5:00 PM",
//     trucksServing: ["4 Ton", "5 Ton", "6 Ton"],
//     mapLink: "https://maps.app.goo.gl/ScRkCn6gB4PcRmGe6",
//     mapEmbedUrl:
//       "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d239.4801207011364!2d42.64558927731002!3d17.178544144899654!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15fd512bffe86785%3A0xa9ba48aec8caadc5!2sFuchs%20One%20Stop%20Sabya!5e1!3m2!1sen!2ssa!4v1772620205329!5m2!1sen!2ssa"
//   },
//   {
//     id: "Al-Baha-service-1",
//     type: "service",
//     city: "Al Baha",
//     isDefault: false,
//     branchName: "LandKing Service Provider - Al Baha",
//     contacts: ["059-6782427"],
//     emails: ["FAB3@FUCHS.COM.SA"],
//     addressText: "Al Baha",
//     workingDays: "Sunday to Thursday",
//     workingTime: "8:00 AM to 5:00 PM",
//     trucksServing: ["4 Ton", "5 Ton", "6 Ton"],
//     mapLink: "https://goo.gl/maps/jvhvFwexNU2Kb4mw9",
//     mapEmbedUrl:
//       "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d477.1523342385047!2d41.47673212961716!3d20.008191246025522!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjDCsDAwJzI5LjYiTiA0McKwMjgnMzcuOCJF!5e1!3m2!1sen!2ssa!4v1772620382824!5m2!1sen!2ssa"
//   },
//   {
//     id: "Buraydah-service-1",
//     type: "service",
//     city: "Buraydah",
//     isDefault: false,
//     branchName: "LandKing Service Provider - Buraydah",
//     contacts: ["057-2585543"],
//     emails: ["FB1@FUCHS.COM.SA"],
//     addressText: "Buraydah",
//     workingDays: "Sunday to Thursday",
//     workingTime: "8:00 AM to 5:00 PM",
//     trucksServing: ["4 Ton", "5 Ton", "6 Ton"],
//     mapLink: "https://maps.app.goo.gl/Y2Lfqz7k55R5977t7",
//     mapEmbedUrl:
//       "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d202.19774025394463!2d43.96411631538177!3d26.35975401237346!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x157f5849b9570d39%3A0x178aba7e9adab5d!2sFuchs%20One%20Stop%20Al%20Safraa!5e1!3m2!1sen!2ssa!4v1772620558861!5m2!1sen!2ssa"
//   },
// ];

// export default function Locations() {
//   const { t, i18n } = useTranslation();
//   const isArabic = i18n.language?.startsWith("ar");

//   // Defaults
//   const [locationType, setLocationType] = useState("showroom");
//   const [city, setCity] = useState("Riyadh");

//   // Used only for showroom selection (since service shows ALL)
//   const [branchId, setBranchId] = useState("");

//   const cities = useMemo(() => {
//     const set = new Set(LOCATIONS.map((l) => l.city));
//     return Array.from(set);
//   }, []);

//   // All matches for current filters
//   const matchingBranches = useMemo(() => {
//     return LOCATIONS.filter((l) => l.type === locationType && l.city === city);
//   }, [locationType, city]);

//   // For SHOWROOM: pick one preferred branch
//   useEffect(() => {
//     if (locationType !== "showroom") return; // ✅ only for showroom

//     if (!matchingBranches.length) {
//       setBranchId("");
//       return;
//     }

//     const preferred = matchingBranches.find((b) => b.isDefault) || matchingBranches[0];
//     setBranchId(preferred.id);
//   }, [matchingBranches, locationType]);

//   const selectedShowroom = useMemo(() => {
//     if (locationType !== "showroom") return null;
//     return LOCATIONS.find((l) => l.id === branchId) || null;
//   }, [branchId, locationType]);

//   const noData = matchingBranches.length === 0;

//   return (
//     <div className="Page">
//       <div className="locationPageBanner text-center">
//         <div className="page-banner-content">
//           <h3>{t("locationPage.bannerSubtitle")}</h3>
//           <h1>{t("locationPage.bannerTitle")}</h1>
//         </div>
//       </div>

//       <section className={`lk-locations-page ${isArabic ? "lk-locations-ar" : "lk-locations-en"}`}>
//         <Container fluid>
//           <div className="section-spacing">
//             <p className="brand-section-desc text-center mb-0">{t("locationPage.tagline")}</p>
//           </div>

//           {/* ✅ Only 2 Filters */}
//           <Row className="lk-location-filters g-3">
//             <Col md={6}>
//               <Form.Group>
//                 <Form.Label className="brand-input-label">
//                   {t("locationPage.filters.typeLabel", "Location Type")}
//                 </Form.Label>
//                 <Form.Select
//                   className="form-select brand-input"
//                   value={locationType}
//                   onChange={(e) => setLocationType(e.target.value)}
//                 >
//                   <option value="showroom">{t("locationPage.filters.showroom", "Showroom")}</option>
//                   <option value="service">
//                     {t("locationPage.filters.serviceProvider", "Service Provider")}
//                   </option>
//                 </Form.Select>
//               </Form.Group>
//             </Col>

//             <Col md={6}>
//               <Form.Group>
//                 <Form.Label className="brand-input-label">
//                   {t("locationPage.filters.cityLabel", "City")}
//                 </Form.Label>
//                 <Form.Select
//                   value={city}
//                   onChange={(e) => setCity(e.target.value)}
//                   className="brand-input"
//                 >
//                   {cities.map((c) => (
//                     <option key={c} value={c}>
//                       {t(`common.cities.${c}`, c)}
//                     </option>
//                   ))}
//                 </Form.Select>
//               </Form.Group>
//             </Col>
//           </Row>

//           {/* ✅ Better no-results message */}
//           {noData && (
//             <Row className="mt-4">
//               <Col md={12}>
//                 <Alert variant="warning" className="lk-location-alert text-center">
//                   {t(
//                     "locationPage.filters.noLocationsBetter",
//                     "No results found for the selected Location Type and City. Please try a different selection."
//                   )}
//                 </Alert>
//               </Col>
//             </Row>
//           )}

//           {/* ✅ SHOWROOM: show single selected showroom (like before) */}
//           {!noData && locationType === "showroom" && selectedShowroom && (
//             <>
//               <Row className="mt-4">
//                 <Col md={5}>
//                   <div className="showroom-pic">
//                     <img
//                       src={selectedShowroom.banner}
//                       alt={t("locationPage.showroomAlt", "Showroom")}
//                     />
//                   </div>
//                 </Col>

//                 <Col md={7}>
//                   <div className="location-details">
//                     <h3>{selectedShowroom.city}</h3>
//                     <p className="lk-branch-name">{selectedShowroom.branchName}</p>
//                   </div>

//                   <Row>
//                     <Col md={6}>
//                       <div className="location-data text-center mt-4">
//                         <div className="location-icon-holder mb-2">
//                           <PhoneCall />
//                         </div>
//                         <div className="location-subdata">
//                           <h5>{t("locationPage.contactLabel", "Contact")}</h5>
//                           {selectedShowroom.contacts?.map((p) => (
//                             <div key={p}>
//                               <a href={`tel:${p}`}>{p}</a>
//                             </div>
//                           ))}
//                         </div>
//                       </div>
//                     </Col>

//                     <Col md={6}>
//                       <div className="location-data text-center mt-4">
//                         <div className="location-icon-holder mb-2">
//                           <MapPin />
//                         </div>
//                         <div className="location-subdata">
//                           <h5>{t("locationPage.addressLabel", "Address")}</h5>
//                           <a href={selectedShowroom.mapLink} target="_blank" rel="noreferrer">
//                             {selectedShowroom.addressText}
//                           </a>
//                         </div>
//                       </div>
//                     </Col>

//                     {/* ✅ Working Hours must be col-12 for Showroom */}
//                     <Col md={12}>
//                       <div className="location-data text-center mt-4">
//                         <div className="location-icon-holder mb-2">
//                           <CalendarClock />
//                         </div>
//                         <div className="location-subdata">
//                           <h5>{t("locationPage.hoursLabel", "Working Hours")}</h5>
//                           <p>{selectedShowroom.workingDays}</p>
//                           <p>{selectedShowroom.workingTime}</p>
//                         </div>
//                       </div>
//                     </Col>
//                   </Row>
//                 </Col>
//               </Row>

//               <div className="location-map mt-4">
//                 <iframe
//                   title={t("locationPage.mapTitle", "Location Map")}
//                   src={selectedShowroom.mapEmbedUrl}
//                   width="100%"
//                   height="450"
//                   style={{ border: 0 }}
//                   allowFullScreen
//                   loading="lazy"
//                   referrerPolicy="no-referrer-when-downgrade"
//                 />
//               </div>
//             </>
//           )}

//           {/* ✅ SERVICE: show ALL service providers in that city */}
//           {/* ✅ SERVICE: show ALL service providers in that city */}
//           {!noData && locationType === "service" && (
//             <>
//               {matchingBranches.map((branch) => (
//                 <div key={branch.id} className="lk-service-provider-block">
//                   <Row className="mt-4">
//                     {/* ✅ Replace banner with map for service providers */}
//                     <Col md={5}>
//                       <div className="location-map location-map--service">
//                         <iframe
//                           title={`${branch.branchName} - Map`}
//                           src={branch.mapEmbedUrl}
//                           width="100%"
//                           height="500"
//                           style={{ border: 0, borderRadius: "14px" }}
//                           allowFullScreen
//                           loading="lazy"
//                           referrerPolicy="no-referrer-when-downgrade"
//                         />
//                       </div>
//                     </Col>

//                     <Col md={7}>
//                       <div className="location-details">
//                         <h3>{t(`common.cities.${branch.city}`, branch.city)}</h3>
//                         <p className="lk-branch-name">{branch.branchName}</p>
//                       </div>

//                       <Row>
//                         <Col md={6}>
//                           <div className="location-data text-center mt-4">
//                             <div className="location-icon-holder mb-2">
//                               <PhoneCall />
//                             </div>
//                             <div className="location-subdata">
//                               <h5>{t("locationPage.contactLabel", "Contact")}</h5>
//                               {branch.contacts?.map((p) => (
//                                 <div key={p}>
//                                   <a href={`tel:${p}`}>{p}</a>
//                                 </div>
//                               ))}
//                             </div>
//                           </div>
//                         </Col>

//                         <Col md={6}>
//                           <div className="location-data text-center mt-4">
//                             <div className="location-icon-holder mb-2">
//                               <Mail />
//                             </div>
//                             <div className="location-subdata">
//                               <h5>{t("locationPage.emailLabel", "Email")}</h5>
//                               {branch.emails?.map((em) => (
//                                 <div key={em}>
//                                   <a href={`mailto:${em}`}>{em}</a>
//                                 </div>
//                               ))}
//                             </div>
//                           </div>
//                         </Col>

//                         <Col md={6}>
//                           <div className="location-data text-center mt-4">
//                             <div className="location-icon-holder mb-2">
//                               <MapPin />
//                             </div>
//                             <div className="location-subdata">
//                               <h5>{t("locationPage.addressLabel", "Address")}</h5>
//                               <a href={branch.mapLink} target="_blank" rel="noreferrer">
//                                 {branch.addressText}
//                               </a>
//                             </div>
//                           </div>
//                         </Col>

//                         {/* ✅ Working Hours card added for Service Providers */}
//                         <Col md={6}>
//                           <div className="location-data text-center mt-4">
//                             <div className="location-icon-holder mb-2">
//                               <CalendarClock />
//                             </div>
//                             <div className="location-subdata">
//                               <h5>{t("locationPage.hoursLabel", "Working Hours")}</h5>
//                               <p>
//                                 {t(
//                                   "locationPage.serviceWorkingDaysMain",
//                                   "Saturday to Thursday"
//                                 )}
//                               </p>
//                               <p>
//                                 {t(
//                                   "locationPage.serviceWorkingTimeMain",
//                                   "8:00 AM to 10:00 PM"
//                                 )}
//                               </p>
//                               <p className="mb-0">
//                                 {t("locationPage.serviceWorkingDaysFriday", "Friday")} —{" "}
//                                 {t("locationPage.serviceWorkingTimeFriday", "4:00 PM to 9:00 PM")}
//                               </p>
//                             </div>
//                           </div>
//                         </Col>
//                       </Row>
//                     </Col>
//                   </Row>
//                 </div>
//               ))}
//             </>
//           )}
//         </Container>
//       </section>

//       <div className="section-spacing-top">
//         <AftersalesSupportSection />
//       </div>
//     </div>
//   );
// }



import React, { useEffect, useMemo, useState } from "react";
import { Container, Row, Col, Form, Alert } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { PhoneCall, MapPin, CalendarClock, Mail } from "lucide-react";
import AftersalesSupportSection from "../../components/sections/AftersalesSupportSection/AftersalesSupportSection";
import LOCATIONS from "../../data/locationsData";
import "./LocationPage.css";

export default function Locations() {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language?.startsWith("ar");

  const [locationType, setLocationType] = useState("showroom");
  const [city, setCity] = useState("Riyadh");
  const [branchId, setBranchId] = useState("");

  const cities = useMemo(() => {
    const set = new Set(LOCATIONS.map((l) => l.city));
    return Array.from(set);
  }, []);

  const matchingBranches = useMemo(() => {
    return LOCATIONS.filter((l) => l.type === locationType && l.city === city);
  }, [locationType, city]);

  useEffect(() => {
    if (locationType !== "showroom") return;

    if (!matchingBranches.length) {
      setBranchId("");
      return;
    }

    const preferred = matchingBranches.find((b) => b.isDefault) || matchingBranches[0];
    setBranchId(preferred.id);
  }, [matchingBranches, locationType]);

  const selectedShowroom = useMemo(() => {
    if (locationType !== "showroom") return null;
    return LOCATIONS.find((l) => l.id === branchId) || null;
  }, [branchId, locationType]);

  const noData = matchingBranches.length === 0;

  return (
    <div className="Page">
      <div className="locationPageBanner text-center">
        <div className="page-banner-content">
          <h3>{t("locationPage.bannerSubtitle")}</h3>
          <h1>{t("locationPage.bannerTitle")}</h1>
        </div>
      </div>

      <section className={`lk-locations-page ${isArabic ? "lk-locations-ar" : "lk-locations-en"}`}>
        <Container fluid>
          <div className="section-spacing">
            <p className="brand-section-desc text-center mb-0">
              {t("locationPage.tagline")}
            </p>
          </div>

          <Row className="lk-location-filters g-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label className="brand-input-label">
                  {t("locationPage.filters.typeLabel")}
                </Form.Label>
                <Form.Select
                  className="form-select brand-input"
                  value={locationType}
                  onChange={(e) => setLocationType(e.target.value)}
                >
                  <option value="showroom">{t("locationPage.filters.showroom")}</option>
                  <option value="service">{t("locationPage.filters.serviceProvider")}</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group>
                <Form.Label className="brand-input-label">
                  {t("locationPage.filters.cityLabel")}
                </Form.Label>
                <Form.Select
                  value={city}
                  onChange={(e) => setCity(e.target.value)}
                  className="brand-input"
                >
                  {cities.map((c) => (
                    <option key={c} value={c}>
                      {t(`common.cities.${c}`, c)}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          {noData && (
            <Row className="mt-4">
              <Col md={12}>
                <Alert variant="warning" className="lk-location-alert text-center">
                  {t("locationPage.filters.noLocationsBetter")}
                </Alert>
              </Col>
            </Row>
          )}

          {!noData && locationType === "showroom" && selectedShowroom && (
            <>
              <Row className="mt-4">
                <Col md={5}>
                  <div className="showroom-pic">
                    <img
                      src={selectedShowroom.banner}
                      alt={t("locationPage.showroomAlt")}
                    />
                  </div>
                </Col>

                <Col md={7}>
                  <div className="location-details">
                    <h3>{t(`common.cities.${selectedShowroom.city}`, selectedShowroom.city)}</h3>
                    <p className="lk-branch-name">
                      {t(selectedShowroom.branchNameKey)}
                    </p>
                  </div>

                  <Row>
                    <Col md={6}>
                      <div className="location-data text-center mt-4">
                        <div className="location-icon-holder mb-2">
                          <PhoneCall />
                        </div>
                        <div className="location-subdata">
                          <h5>{t("locationPage.contactLabel")}</h5>
                          {selectedShowroom.contacts?.map((p) => (
                            <div key={p}>
                              <a href={`tel:${p}`}>{p}</a>
                            </div>
                          ))}
                        </div>
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="location-data text-center mt-4">
                        <div className="location-icon-holder mb-2">
                          <MapPin />
                        </div>
                        <div className="location-subdata">
                          <h5>{t("locationPage.addressLabel")}</h5>
                          <a href={selectedShowroom.mapLink} target="_blank" rel="noreferrer">
                            {t(selectedShowroom.addressTextKey)}
                          </a>
                        </div>
                      </div>
                    </Col>

                    <Col md={12}>
                      <div className="location-data text-center mt-4">
                        <div className="location-icon-holder mb-2">
                          <CalendarClock />
                        </div>
                        <div className="location-subdata">
                          <h5>{t("locationPage.hoursLabel")}</h5>
                          <p>{t(selectedShowroom.workingDaysKey)}</p>
                          <p>{t(selectedShowroom.workingTimeKey)}</p>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <div className="location-map mt-4">
                <iframe
                  title={t("locationPage.mapTitle")}
                  src={selectedShowroom.mapEmbedUrl}
                  width="100%"
                  height="450"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            </>
          )}

          {!noData && locationType === "service" && (
            <>
              {matchingBranches.map((branch) => (
                <div key={branch.id} className="lk-service-provider-block">
                  <Row className="mt-4">
                    <Col md={5}>
                      <div className="location-map location-map--service">
                        <iframe
                          title={`${t(branch.branchNameKey)} - ${t("locationPage.mapTitle")}`}
                          src={branch.mapEmbedUrl}
                          width="100%"
                          height="500"
                          style={{ border: 0, borderRadius: "14px" }}
                          allowFullScreen
                          loading="lazy"
                          referrerPolicy="no-referrer-when-downgrade"
                        />
                      </div>
                    </Col>

                    <Col md={7}>
                      <div className="location-details">
                        <h3>{t(`common.cities.${branch.city}`, branch.city)}</h3>
                        <p className="lk-branch-name">{t(branch.branchNameKey)}</p>
                      </div>

                      <Row>
                        <Col md={6}>
                          <div className="location-data text-center mt-4">
                            <div className="location-icon-holder mb-2">
                              <PhoneCall />
                            </div>
                            <div className="location-subdata">
                              <h5>{t("locationPage.contactLabel")}</h5>
                              {branch.contacts?.map((p) => (
                                <div key={p}>
                                  <a href={`tel:${p}`}>{p}</a>
                                </div>
                              ))}
                            </div>
                          </div>
                        </Col>

                        <Col md={6}>
                          <div className="location-data text-center mt-4">
                            <div className="location-icon-holder mb-2">
                              <Mail />
                            </div>
                            <div className="location-subdata">
                              <h5>{t("locationPage.emailLabel")}</h5>
                              {branch.emails?.map((em) => (
                                <div key={em}>
                                  <a href={`mailto:${em}`}>{em}</a>
                                </div>
                              ))}
                            </div>
                          </div>
                        </Col>

                        <Col md={6}>
                          <div className="location-data text-center mt-4">
                            <div className="location-icon-holder mb-2">
                              <MapPin />
                            </div>
                            <div className="location-subdata">
                              <h5>{t("locationPage.addressLabel")}</h5>
                              <a href={branch.mapLink} target="_blank" rel="noreferrer">
                                {t(branch.addressTextKey)}
                              </a>
                            </div>
                          </div>
                        </Col>

                        <Col md={6}>
                          <div className="location-data text-center mt-4">
                            <div className="location-icon-holder mb-2">
                              <CalendarClock />
                            </div>
                            <div className="location-subdata">
                              <h5>{t("locationPage.hoursLabel")}</h5>
                              <p>{t("locationPage.serviceWorkingDaysMain")}</p>
                              <p>{t("locationPage.serviceWorkingTimeMain")}</p>

                              {branch.fridayAvailable ? (
                                <p className="mb-0">
                                  {t("locationPage.serviceWorkingDaysFriday")} —{" "}
                                  {t("locationPage.serviceWorkingTimeFriday")}
                                </p>
                              ) : (
                                <p className="mb-0">
                                  {t("locationPage.serviceWorkingDaysFriday")} —{" "}
                                  {t("locationPage.closedOnFriday")}
                                </p>
                              )}
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </div>
              ))}
            </>
          )}
        </Container>
      </section>

      <div className="section-spacing-top">
        <AftersalesSupportSection />
      </div>
    </div>
  );
}